module.exports = __webpack_public_path__ + "static/media/Intelliclose.d8d40e0e.svg";